<template>
  <div id="main-content" class="bus-notification-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <template v-if="data">
        <el-row style="padding-top: 20px">
          <table class="bus-list filter-sort-table">
            <tr>
              <th width="5%">#</th>
              <th width="15%" class="input-th">
                <el-input :placeholder="$t('common.title')" v-model="filter.title"></el-input>
                <Sort :model="sort.title" @change="changeSort($event, 'title')"></Sort>
              </th>
              <th width="25%" class="input-th">
                <el-input :placeholder="$t('common.content')" v-model="filter.content"></el-input>
                <Sort :model="sort.content" @change="changeSort($event, 'content')"></Sort>
              </th>
              <th width="10%" class="input-th">
                <el-input :placeholder="$t('common.bus')" v-model="filter.bus_name"></el-input>
                <Sort :model="sort.bus_name" @change="changeSort($event, 'bus_name')"></Sort>
              </th>
              <th width="10%" class="input-th">
                <el-input :placeholder="$t('common.sub_driver')" v-model="filter.sub_driver_name"></el-input>
                <Sort :model="sort.sub_driver_name" @change="changeSort($event, 'sub_driver_name')"></Sort>
              </th>
              <th width="26%" class="input-th">
                <el-date-picker
                    v-model="filter.start_date"
                    type="date"
                    :placeholder="$t('common.start_date')"
                    class="date-picker"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span>~</span>
                <el-date-picker
                    v-model="filter.end_date"
                    type="date"
                    :placeholder="$t('common.end_date')"
                    class="date-picker"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <Sort :model="sort.created_at" @change="changeSort($event, 'created_at')"></Sort>
              </th>
              <th>
                <el-button @click="resetFilter"
                   style="margin: 2px;" type="danger">{{ $t('common.reset') }}
                </el-button>
              </th>
            </tr>
            <tr v-for="(busNotification, index) in data.data" :key="busNotification.id">
              <td class="notification-no" :class="{ 'is-unread': !busNotification.is_read }">
                {{ data.from + index }}
                <span class="notification-badge"></span>
              </td>
              <td>{{ busNotification.title }}</td>
              <td>{{ busNotification.content }}</td>
              <td>{{ busNotification.bus_name }}</td>
              <td>{{ busNotification.sub_driver_name }}</td>
              <td>{{ $moment(busNotification.created_at).format('YYYY-MM-DD H:mm:ss') }}</td>
              <td>
                <b-button variant="outline-primary" @click="goToDetail(busNotification.id)"
                          style="margin-right: 10px">{{ $t('common.detail') }}
                </b-button>
              </td>
            </tr>
          </table>
        </el-row>
        <el-row style="padding-top: 15px">
          <el-pagination
              v-show="data.total > data.per_page"
              background
              @current-change="didSelectPage"
              :page-size="data.per_page"
              layout="prev, pager, next"
              :current-page="page"
              :total="data.total">
          </el-pagination>
        </el-row>
      </template>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import { USER_NOTIFICATION_TYPE_BUS } from '@/config'
  import PageTitle from '@/components/PageTitle'
  import Sort from '@/components/Sort'

  export default {
    name: 'ListBusNotification',
    components: {
      PageTitle,
      Sort
    },
    data: function () {
      return {
        backLink: ``,
        title: 'notification.bus_notification_list',
        page: 1,
        filter: {
          title: '',
          content: '',
          bus_name: '',
          sub_driver_name: '',
          start_date: null,
          end_date: null
        },
        sort: {
          title: null,
          content: null,
          bus_name: null,
          sub_driver_name: null,
          created_at: null
        },
        isBack: false,
        data: null,
        filterTimeout: null
      }
    },
    methods: {
      goToDetail(notificationId) {
        this.saveState()
        this.$router.push({path: '/notification/bus/detail', query: {id: notificationId}});
      },
      didSelectPage: function (e) {
        this.page = e
        this.retrieveData()
      },
      saveState: function () {
        this.$store.commit('notification/updateBusNotificationState', {
          filter: this.filter,
          sort: this.sort,
          page: this.page
        })
      },
      resetFilter: function () {
        this.filter = Object.assign({}, {
          title: '',
          content: '',
          bus_name: '',
          sub_driver_name: '',
          start_date: null,
          end_date: null
        })

        this.sort = Object.assign({}, {
          title: null,
          content: null,
          bus_name: null,
          sub_driver_name: null,
          created_at: null
        })
      },
      changeSort (type, field) {
        this.sort[field] = type
        this.sort = Object.assign({}, this.sort)
        this.retrieveData()
      },
      retrieveData: function () {
        let filter = this.filter
        let sort = this.sort
        let page = this.page
        let successCallback = (response) => {
          this.data = Object.assign({}, response.data.data)
        }

        this.$store.dispatch('notification/retrieveBusNotificationList', {
          filter, sort, page, successCallback
        })
      },
      canAddNew: function (notification) {
        if (notification.type !== USER_NOTIFICATION_TYPE_BUS) {
          return false
        }

        if (this.page !== 1) {
          return false
        }

        if (this.filter.title && notification.title.indexOf(this.filter.title) === -1) {
          return false
        }

        if (this.filter.content && notification.content.indexOf(this.filter.content) === -1) {
          return false
        }

        if (this.filter.bus_name && notification.bus_name.indexOf(this.filter.bus_name) === -1) {
          return false
        }

        if (this.filter.sub_driver_name && notification.sub_driver_name.indexOf(this.filter.sub_driver_name) === -1) {
          return false
        }

        if (this.filter.start_date
            && this.$moment(notification.created_at).format('YYYY-MM-DD') < this.filter.start_date) {
          return false
        }

        if (this.filter.end_date
            && this.$moment(notification.created_at).format('YYYY-MM-DD') > this.filter.end_date) {
          return false
        }
      }
    },
    created: function () {
      if (this.$route.query.action && this.$route.query.action === "back") {
        if (this.currentBusNotificationFilter) {
          this.filter = Object.assign({}, this.currentBusNotificationFilter)
          this.isBack = true
        }

        if (this.currentBusNotificationSort) {
          this.sort = Object.assign({}, this.currentBusNotificationSort)
        }

        if (this.currentBusNotificationPage) {
          this.page = this.currentBusNotificationPage
        }
      }

      this.$store.commit('notification/updateBusNotificationState', {
        filter: null,
        sort: null,
        page: null
      })
    },
    mounted: function () {
      this.retrieveData()
    },
    computed: {
      ...mapState('notification', [
        'currentBusNotificationFilter',
        'currentBusNotificationSort',
        'currentBusNotificationPage'
      ])
    },
    watch: {
      filter: {
        deep: true,
        handler: function () {
          if (this.isBack) {
            this.isBack = false
            return
          }

          clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            this.retrieveData()
          }, 1000)

          this.page = 1
        }
      }
    },
    sockets: {
      notifications (notification) {
        if (this.canAddNew(notification.data)) {
          if (this.data.data.length >= this.data.per_page) {
            this.data.data.pop()
          }

          this.data.data.unshift(notification.data)
        }
      },
      notificationRead (notification) {
        if (notification.type === USER_NOTIFICATION_TYPE_BUS) {
          this.data.data.forEach((item) => {
            if (item.id === notification.data.id) {
              item.is_read = true
            }
          })
        }
      }
    }
  }
</script>
<style lang="scss">
  .bus-notification-list {
    .input-th {
      .date-picker {
        width: 150px;
      }

      > span {
        margin: 0 10px;
      }
    }

    .notification-no {
      position: relative;

      .notification-badge {
        width: 10px;
        height: 10px;
        border-radius: 100%;
        position: absolute;
        top: 5px;
        left: 5px;
        background: #ca0000;
        display: none;
      }

      &.is-unread {
        .notification-badge {
          display: block;
        }
      }
    }
  }
</style>
